module.exports = __webpack_public_path__ + "img/choose-super-pass-friday.d7794906.webp";